import { SpaceBetween } from '@cloudscape-design/components';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { HydroPiSample } from '../components/modules/HydroPi';
import { Batch } from '../models/Batch';
import { toDate } from '../utils/timestamp';
import { useModuleTranslation } from '../lang';

interface TiltsWidgetProps {
  tilts: HydroPiSample[];
  batches: Batch[];
}

const TiltsWidget: FC<TiltsWidgetProps> = ({ tilts, batches }) => {
  const nav = useNavigate();
  const t = useModuleTranslation('TiltsWidget');
  return (
    <SpaceBetween size="s" direction="vertical">
      {tilts.map((sample) => {
        const batch =
          batches.find(
            (b) =>
              b.hydroPi?.color === sample.color &&
              toDate(b?.hydroPi?.startDate) < toDate(sample.timestamp) &&
              (b?.hydroPi?.startDate?.seconds ?? 0) - (b?.hydroPi?.endDate?.seconds ?? 0) > 0,
          ) ??
          batches.find(
            (b) => b.hydroPi?.color === sample.color && toDate(b?.hydroPi?.startDate) < toDate(sample.timestamp),
          );

        const name = batch?.name ?? sample.color;

        return (
          <div
            key={sample.id}
            className="pointer"
            onClick={() => {
              nav('/batches/' + batch?.id);
            }}
            style={{
              width: '100%',
              height: 56,
              position: 'relative',
              backgroundColor: sample.color,
              color: sample.color === 'white' ? 'black' : 'white',
              borderRadius: 5,
              border: '1px solid grey',
              overflow: 'hidden',
              padding: 5,
            }}
          >
            <div
              style={{
                fontWeight: 'bold',
                fontSize: name.length > 10 ? 20 : 24,
                position: 'absolute',
                top: 5,
                right: 5,
              }}
            >
              {name}
            </div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: 18,
                position: 'absolute',
                top: 5,
                left: 5,
              }}
            >
              {sample.avg_temp_c.toFixed(1)}°C
            </div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: 18,
                position: 'absolute',
                bottom: 5,
                left: 5,
              }}
            >
              {sample.avg_gravity.toFixed(3)}
            </div>

            <div
              style={{
                fontWeight: 'bold',
                fontSize: 18,
                position: 'absolute',
                top: 5,
                left: '40%',
              }}
            >
              {Math.round((Date.now() - toDate(sample.timestamp).getTime()) / 3600000)} {t.hoursAgo}
            </div>
          </div>
        );
      })}
    </SpaceBetween>
  );
};

export default TiltsWidget;
